import { type TFunction } from '!/i18n'
import {
  formatDateDuration,
  formatDateToLabelInfo,
  timeWithin,
} from '~/shared/helpers/date'
import { type LiveProgramInfo, type LiveProgramLocalizedInfo } from './index.h'

export const formatToLocalizedView =
  ({ now, t }: { now: number; t: TFunction }) =>
  (info: LiveProgramInfo): LiveProgramLocalizedInfo => {
    // format left time label
    const { hours, minutes } = timeWithin(now, info.actualStopMs)
    const formattedDuration = formatDateDuration({
      duration: { hours, minutes },
      short: true,
    })

    const labelLeft = t('time_left', {
      time: formattedDuration,
    })
    // format duration label
    const labelDuration = formatDateToLabelInfo(
      info.actualStartMs,
      info.actualStopMs
    )

    // format empty description
    const emptyDescription = t('no_epg_data')

    return {
      ...info,
      labelLeft,
      labelDuration,
      emptyDescription,
    }
  }
